<template>
    <div class="container">
        <div class="category-search-box-dropdown" >
            <BlockCategoryDropdown v-on:searchCat="cat($event)" withSearch :type="type" />
<!--            <BlockEventDropdown v-on:searchCat="cat($event)" withSearch v-if="type == 'package'" :type="type" />-->
            <BlockSearchBox withFilter :type="type"/>
        </div>
    </div>
</template>

<script>
    import BlockCategoryDropdown from './BlockCategoryDropdown.vue';
    // import BlockEventDropdown from './BlockEventDropdown.vue';
    import BlockSearchBox from './BlockSearchBox.vue';
	//import axios from "axios";
    export default {
        components: {
            BlockSearchBox,
            BlockCategoryDropdown,
			// BlockEventDropdown
		},
		props: {
			type: String
		},
		methods: {
			cat: function(searchCat) {
				this.searchCat = searchCat;
			},
			data() {
				return {
					searchText: '',
					searchCat: ''
				};
			}
		}
    };
</script>

<style lang="scss" scoped>
    .category-search-box-dropdown {
        display: flex;
        margin-top: 30px;
        position: relative;
        .category-dropdown {
            z-index: 2;
            position: static;
        }
        .search-box {
            width: calc(100% - 246px);
            margin-left: -24px;
        }
        @include mq($md) {
            flex-direction: column-reverse;
            .search-box {
                width: 100%;
                margin-left: 0;
                margin-bottom: 20px;
            }
        }
    }
</style>
